<div class="controls-wrapper">
  <button class="scroll-btn" (click)="scrollUp.emit()" [disabled]="disableUp">
    <i class="fas fa-angle-up"></i>
  </button>
  <button class="scroll-btn" (click)="scrollDown.emit()" [disabled]="disableDown">
    <i class="fas fa-angle-down"></i>
  </button>
</div>